import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import classNames from "classnames";
import React from "react";
import { ArrowCircleIcon } from "../icons/ArrowCircleIcon";
import { IVisual, Visual } from "../shared/Visual";

export const VideoWithLink: React.FC<{
  visual: IVisual;
  internalLink?: string | null;
  linkTitle?: string | null;
  showLinkAsButton?: boolean | null;
  subHeading?: string | null;
  heading?: string | null;
}> = ({
  visual,
  internalLink,
  linkTitle,
  subHeading,
  heading,
  showLinkAsButton,
}) => {
  return (
    <section
      data-component="Video With Link"
      className="page-grid relative pb-32px lg:pb-0"
    >
      {(internalLink ?? linkTitle ?? subHeading ?? heading) && (
        <div className="col-span-4 col-start-2 row-start-1 mt-48px flex flex-col justify-center lg:col-span-4 lg:col-start-3 lg:mt-0">
          {subHeading && <p className="h6 text-hyacinth">{subHeading}</p>}
          {heading && <h1 className="h3 mt-10px text-coal">{heading}</h1>}
          {internalLink && linkTitle && (
            <Link
              to={internalLink}
              className={classNames(
                showLinkAsButton
                  ? "servicesButton"
                  : "h5 mb-48px mt-32px flex w-full gap-x-10px text-hyacinth lg:mb-0 lg:mt-48px",
              )}
            >
              {linkTitle}
              {!showLinkAsButton && (
                <ArrowCircleIcon className="h-20px -rotate-90 transform-gpu self-center lg:h-30px" />
              )}
            </Link>
          )}
        </div>
      )}
      <Visual
        visual={visual}
        // delay={100}
        className="col-span-full col-start-1 row-start-2 lg:col-span-8 lg:col-start-7 lg:row-start-1"
      />
    </section>
  );
};
